import script from "./custom-bar-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./custom-bar-chart.vue?vue&type=script&lang=ts&setup=true"

import "./custom-bar-chart.vue?vue&type=style&index=0&id=7221f834&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7221f834"]])

export default __exports__